export default "__VITE_ASSET__59343761__"